import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

//debugger
const routes: Routes = [
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./../../views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '', redirectTo: 'dashboard', pathMatch: 'full'
      },
      {
        path: 'users',
        loadChildren: () => import('./../../views/pages/master/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'profile/:id/:actionInfo',
        loadChildren: () => import('./../../views/pages/profile/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'monthlyreport',
        loadChildren: () => import('./../../views/pages/reports/monthlyreport/monthlyreport.module').then(m => m.MonthlyReportModule)
      },
      {
        path: 'genderwisechildcount',
        loadChildren: () => import('./../../views/pages/reports/genderwisechildcountreport/genderwisechildcountreport.module').then(m => m.GenderWiseChildcountReportModule)
      },
      {
        path: 'district',
        loadChildren: () => import('./../../views/pages/master/district/district.module').then(m => m.DistrictModule)
      },
      {
        path: 'block',
        loadChildren: () => import('./../../views/pages/master/block/block.module').then(m => m.BlockModule)
      },
      {
        path: 'sector',
        loadChildren: () => import('./../../views/pages/master/sector/sector.module').then(m => m.SectorModule)
      },
      {
        path: 'awc',
        loadChildren: () => import('./../../views/pages/master/awc/awc.module').then(m => m.AwcModule)
      },
      {
        path: 'grid',
        loadChildren: () => import('./../../views/pages/grid/grid.module').then(m => m.gridModule)
      },
      {
        path: 'cookingcentrewisereport',
        loadChildren: () => import('./../../views/pages/reports/district-wise-report/district-report.module').then(m => m.DistrictReportModule)
      },
      {
        path: 'schoolwisereport',
        loadChildren: () => import('./../../views/pages/reports/schoolwisereport/schoolwisereport.module').then(m => m.SchoolReportModule)
      },
      {
        path: 'holidaycalendar',
        loadChildren: () => import('./../../views/pages/holidaycalendar/holidaycalendar.module').then(m => m.HolidaycalendarModule)
      },
      {
        path: 'vehicletracking',
        loadChildren: () => import('./../../views/pages/vehicleTracking/vehicleTracking.module').then(m => m.VehicleTrackingModule)
      },
      {
        path: 'vehicletracking',
        loadChildren: () => import('./../../views/pages/vehicleTracking/vehicleTracking.module').then(m => m.VehicleTrackingModule)
      },
      {
        path: 'cookingcenterpriodsreport',
        loadChildren: () => import('./../../views/pages/reports/cookingcenterpriods/cookingcenterpriods.module').then(m => m.CookingcenterpriodsModule)
      },
      {
        path: 'hostelschoolpriodsreport',
        loadChildren: () => import('./../../views/pages/reports/hostelschoolperiod/hostelschoolperiod.module').then(m => m.HostelschoolperiodModule)
      },
      {
        path: 'foodmenu',
        loadChildren: () => import('./../../views/pages/foodmenu/foodmenu.module').then(m => m.FoodmenuModule)
      },
      {
        path: 'hostelreport',
        loadChildren: () => import('./../../views/pages/reports/hostelreport/hostelreport.module').then(m => m.HostelreportModule)
      },

      {
        path: 'cookingcenterreport',
        loadChildren: () => import('./../../views/pages/reports/cookingreport/cookingreport.module').then(m => m.CookingreportModule)
      },
      {
        path: 'committeemember',
        loadChildren: () => import('./../../views/pages/commiteemember/commiteemember.module').then(m => m.CommiteememberModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./../../views/pages/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'committedashboard',
        loadChildren: () => import('./../../views/pages/committeedashboard/committeedashboard.module').then(m => m.CommitteedashboardModule)
      },
      {
        path: 'playback',
        loadChildren: () => import('./../../views/pages/playback/playback.module').then(m => m.PlaybackModule)
      },
      {
        path: 'foodqualityreport',
        loadChildren: () => import('./../../views/pages/foodqualityreport/foodqualityreport.module').then(m => m.FoodqualityreportModule)
      },
      {
        path: 'foodquantityreport',
        loadChildren: () => import('./../../views/pages/foodquantityreport/foodquantityreport.module').then(m => m.FoodquantityreportModule)
      },
      {
        path: 'pmucookingcenterreport',
        loadChildren: () => import('./../../views/pages/PMUcookingcenterreport/PMUcookingcenterreport.module').then(m => m.PMUcookingcenterreportModule)
      },
      {
        path: 'pmuhostelreport',
        loadChildren: () => import('./../../views/pages/PMUhostelreport/PMUhostelreport.module').then(m => m.PMUhostelreportModule)
      },
      {
        path: 'school',
        loadChildren: () => import('./../../views/pages/master/schools/school.module').then(m => m.SchoolModule)
      },
      {
        path: 'cookingcenter',
        loadChildren: () => import('./../../views/pages/master/cookingscenter/cookingcenter.module').then(m => m.CookingcenterModule)
      },
      {
        path: 'cookingschoolmap/:id',
        loadChildren: () => import('./../../views/pages/master/cookingschoolmaps/cookingschoolmap.module').then(m => m.CookingschoolmapModule)
      },

      {
        path: 'inspectionDashboard',
        loadChildren: () => import('./../../views/pages/InspectionDashboard/inspectionDashboard.module').then(m => m.InspectionDashboardModule)
      },
      {
        path: 'route',
        loadChildren: () => import('./../../views/pages/master/routes/route.module').then(m => m.RouteModule)
      },
       {
        path: 'regionreport',
        loadChildren: () => import('./../../views/pages/reports/abstactrepotmuncipality/abstactrepotmuncipality.module').then(m => m.AbstractreportmuncipalityModule)
      },
      {
        path: 'corporationreport',
        loadChildren: () => import('./../../views/pages/reports/abstactrepotmuncipality/abstactrepotmuncipality.module').then(m => m.AbstractreportmuncipalityModule)
      },
      {
        path: 'municipalityreport',
        loadChildren: () => import('./../../views/pages/reports/abstactrepotmuncipality/abstactrepotmuncipality.module').then(m => m.AbstractreportmuncipalityModule)
      },
       {
        path: 'foodcenterreport',
        loadChildren: () => import('./../../views/pages/reports/hostelreport/hostelreport.module').then(m => m.HostelreportModule)
      },
       {
        path: 'dailyreport',
        loadChildren: () => import('./../../views/pages/reports/santiaryworkerreport/sanitaryworkerreport.module').then(m => m.SanitaryworkerreportModule)
      },
       {
        path: 'foodcenterdailyreport',
        loadChildren: () => import('./../../views/pages/reports/santiaryworkerreport/sanitaryworkerreport.module').then(m => m.SanitaryworkerreportModule)
      },
      {
        path: 'Santryworkerreport',
        loadChildren: () => import('./../../views/pages/reports/santiaryworkerreport/sanitaryworkerreport.module').then(m => m.SanitaryworkerreportModule)
      },
    ],

  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
